<template>
    <div class="comm-tags-container p-2" id="bookmarks_bar" :class="{'apply-config-mode-styles' : enableFavConfigMode == true}">
        <template v-if="enableFavConfigMode">
            <div class="bookmarks-bar " style="max-width: 92%;">
            <template v-for="fav in favoritesList">
                <div v-if="fav.show_in_bookmark_bar"  :key="fav._id" class="comm-tag-styles comm-config-filters-tag-style">
                    <div v-if="getfavThumbnail(fav)" style="height: 25px;width: 25px;">
                        <img :src="getfavThumbnail(fav)" style="height:100%;width:100%;border-radius: 7px;">
                      </div>
                      <div v-else-if="fav.type == 'bookmark'" v-html="bookmarkSVG" class="text-center" style="position:relative">
                      </div>
                      <div v-else v-html="savedSearchSVG" class="text-center" style="position:relative"></div>
                      <div class="ml-1">{{fav.name}}</div>
                      <edit-icon @click.native="showFavouriteEditWindow(fav)" style="margin-inline-start:8px;width:30px" class="comm-icon-button"></edit-icon>
                      <cancel-icon @click.native="removeAddedFavourites(fav)" style="width:25px;height:25px;margin-inline-start:0px" class="comm-icon-button p-0"></cancel-icon>
                </div>
              </template>
            </div>
            <div style="display: flex;margin-inline-start: 11px;">
                <div v-if="enableFavConfigMode" @click="openAddFavdialog = true" class="add-fav-button">{{$t('Add')}}</div>
                <div v-if="enableFavConfigMode" @click="enableFavConfigMode = false,filterFavouritesBy = ''" class="reset-button blinking-button" style="padding: 5px 10px !important;height: 33px;">Exit</div>
            </div>
            </template>
        <template v-if="!enableFavConfigMode">
            <div class="bookmarks-bar ">
                <div v-if="favoritesList.filter(e => e.show_in_bookmark_bar).length == 0" style="color: #757575;">{{$t('No Bookmarks are added')}}</div>
                <template v-for="fav in favoritesList">
                    <div  @click="loadSelectedFavourite(fav)" :key="fav._id" v-if="fav.show_in_bookmark_bar" class="comm-tag-styles">
                        <div v-if="getfavThumbnail(fav)" style="height: 25px;width: 25px;">
                        <img :src="getfavThumbnail(fav)" style="height:100%;width:100%;border-radius: 7px;">
                        </div>
                        <div v-else-if="fav.type == 'bookmark'" v-html="bookmarkSVG" class="text-center icon-class" style="position:relative">
                        </div>
                        <div v-else v-html="savedSearchSVG" class="text-center" style="position:relative"></div>
                        <div class="ml-1">{{fav.name}}</div>
                    </div>
                </template>
            </div>
            <div @click="clickToPinBookmarksbar()" title="Pin Bookmarks bar" class="comm-icon-button ml-1 p-1">
                <svg v-if="!pinnedBookmarks" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pin-angle" viewBox="0 0 16 16">
                    <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146m.122 2.112v-.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a5 5 0 0 0-.288-.076 5 5 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a5 5 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034q.172.002.343-.04L9.927 2.028q-.042.172-.04.343a1.8 1.8 0 0 0 .062.46z"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" :class="{pinned:pinnedBookmarks}" width="20" height="20" fill="currentColor" class="bi bi-pin-angle-fill" viewBox="0 0 16 16">
                    <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146"/>
                </svg>
            </div>
            <div class="comm-icon-button ml-0 p-1"><svg  xmlns="http://www.w3.org/2000/svg" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" width="20" height="20" fill="currentColor" class="bi bi-three-dots-vertical more-actions-icon icon-background-on-hover dropdown-toggle ml-0" viewBox="0 0 16 16">
                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
              </svg>
              <div class="dropdown-menu dropdown-menu-md-right p-0">
                  <a @click="enableFavConfigMode = true" class="dropdown-item p-2">
                      <span>{{$t('Edit')}}</span>
                  </a>
                  <a @click="hideBookmarksBar()" class="dropdown-item p-2">
                    <span>{{$t('Hide Bookmarks')}}</span>
                </a>
              </div>
            </div>
        </template>
        <div v-if="openAddFavdialog" class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{$t('Select')}}</h6>
                        <button @click="openAddFavdialog = false" type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
                    width: 30px !important;
                    color: #fff;"></cancel-icon></span>
                        </button>
                    </div>
            
                    <div class="modal-body">
                        <div class="search-bar-comm-style">
                                <input type="text" v-model="filterFavouritesBy" class="bg-transparent rounded text-light" ref="focus"
                                    placeholder="Search by name">
                                <cancel-icon v-if="filterFavouritesBy.length > 0" @click="filterFavouritesBy = ''" style="inset-inline-end :3px;top: 5px;width:30px;height:30px;"></cancel-icon>
                                <svg v-else width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                                    <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                                </svg>
                        </div>
                        <div class="col-md-12 pl-0 pt-0 ml-2" style="overflow: auto;height: calc(100% - 50px);">
                            <template  v-for="(panels, type, index) in getFilteredFavourites">
                                <hr v-if="index !== 0" :key="index" style="border-top: 1px solid #2a2a2a;margin-top: 10px;margin-bottom: 0px;">
                                <div :key="index">
                                    <div class="ml-1 panel-headers" style="margin:15px;font-size:16px">
                                        <svg v-if="!openedPanel.includes(type)" v-on:click.stop.prevent="addToPanel(type)"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#aaa" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                        </svg>
                                        <svg v-else v-on:click.stop.prevent="removePanel(type)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#aaa" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                            <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                        </svg>
                                        {{ type }}</div>
                                        <ul v-if="!openedPanel.includes(type)" class="tags-display-ul p-0 active-tag m-0">
                                            <template  v-for="fav in panels">
                                                <li v-on:click="selectFavourite(fav)" :key="fav._id"
                                                :class="{activePanel: fav.show_in_bookmark_bar}" class='view-tags'>
                                                    <div v-if="fav.cover_photo" style="height: 35px;width: 35px;">
                                                        <img :src="getProxyConvertedURL(fav.cover_photo)" style="height:100%;width:100%;border-radius: 7px;">
                                                    </div>
                                                    <div v-else-if="fav.type == 'bookmark'" class="text-center" style="position:relative;top:1px" v-html="bookmarkSVG"></div>
                                                    <div v-else-if="fav.type == 'Saved Search'" class="text-center" style="position:relative" v-html="savedSearchSVG"></div>
                                                    <span :title="fav.name">{{fav.name}}</span>
                                                </li>
                                            </template>
                                        </ul>
                                </div>
                                </template>
                            <div v-if="favoritesList.length === 0" class="no-data-found" style="height: 100%;display:flex;align-items:center;justify-content:center;">{{$t('No Bookmarks are added')}}</div>
                        </div>
                    </div>
                    <div class="modal-footer p-1 primary-btn-style">
                        <div>
                            <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click="openAddFavdialog = false,filterFavouritesBy = '',cancelFavsUpdate()">{{$t('Cancel')}}</button>
                            <button class="btn btn-outline-primary ml-1 mr-2" @click="openAddFavdialog = false,saveSelectedFavourites(),filterFavouritesBy = ''">{{$t('Save')}}</button>
                        </div>
                    </div>
                </div>  
            </div>
         </div>
    </div>
</template>


<script>
import Utils from '../../components.utils';
import cancelIcon from "../core/InlineCancelField.vue";
import editIcon from "../core/InlineEditField.vue";
import { mapActions,mapGetters,mapMutations } from "vuex";
import {NotifierConstants} from "../../components.constants.js";

export default {
    props:['favoritesList'],
    data(){
        return{
            enableFavConfigMode:false,
            bookmarkSVG:Utils.getBookmarkSvg(),
            savedSearchSVG:Utils.getSavedSearchSvg(),
            pinnedBookmarks:false,
            openAddFavdialog:false,
            filterFavouritesBy:'',
            favoritesListToDisplay:[],
            openedPanel:[]
        }
    },
    components:{
        'cancel-icon':cancelIcon,
        'edit-icon':editIcon
    },
    watch:{
        favoritesList:{
            handler(){
                this.favoritesListToDisplay = JSON.parse(JSON.stringify(this.favoritesList));
            },
            deep:true
        }
    },
    methods: {
        getProxyConvertedURL(url){
            return Utils.convertToLoginIPDomainName(url);
        },
        addToPanel(type){
            if(this.openedPanel.includes(type)){
                return;
            }
            this.openedPanel.push(type);
        },
        removePanel(type){
            this.$set(this, 'openedPanel', this.openedPanel.filter(e => e !== type));
        },
        saveSelectedFavourites(){
            for(let i = 0; i < this.favoritesListToDisplay.length; i++){
                let payload = { _id: this.favoritesListToDisplay[i]._id, params: { _id: this.favoritesListToDisplay[i]._id } };
                let checkIndex = this.favoritesList.findIndex(fav => fav._id === this.favoritesListToDisplay[i]._id);
                if(checkIndex >= -1){
                    if(this.favoritesList[checkIndex].show_in_bookmark_bar != this.favoritesListToDisplay[i].show_in_bookmark_bar){
                        payload["show_in_bookmark_bar"] = this.favoritesListToDisplay[i].show_in_bookmark_bar;
                        this.updateExistingFavorite(payload).then(data => {
                            if (!Utils.isAcceptedStatusCode(data.statusCode)) {
                                this.$toast.error(data.message);
                            }
                        });
                    }
                }
            }
        },
        selectFavourite(favInfo){
            favInfo.show_in_bookmark_bar = !favInfo.show_in_bookmark_bar;
        },
        getfavThumbnail(favInfo){
            if(favInfo.cover_photo && favInfo.cover_photo.length > 0){
                return  Utils.convertToLoginIPDomainName(favInfo.cover_photo)
            }else{
                return null
            }
        },
        showFavouriteEditWindow(favInfo){
            this.$emit("showFavouriteEditWindow",favInfo)
        },

        loadSelectedFavourite(favInfo){
            this.$emit("loadSelectedFavourite",favInfo)
        },

        hideBookmarksBar(){
            if(this.pinnedBookmarks){
                if(confirm("Bookmarks bar is pinned. Do you want to unpin it and hide?")){
                    this.pinnedBookmarks = false;
                    let payload = {'_id':this.getLoggedInUserId(),params:{'pinned_bookmarks':this.pinnedBookmarks}};
                    this.updateUserPreferences(payload).then(data => {
                        if (Utils.isAcceptedStatusCode(data.statusCode)) {
                            this.$toast.success(data.message);
                            this.$emit("hideBookmarksBar")
                        } else {
                            this.$toast.error(data.message);
                        }
                    });
                }
            }else{
                this.$emit("hideBookmarksBar")
            }
        },
        removeAddedFavourites(favInfo){
            if(confirm("Are you sure you want to remove this favourite from the bookmarks bar?")){
                let payload = { _id: favInfo._id, params: { _id: favInfo._id } };
                payload["show_in_bookmark_bar"] = false;
                this.updateExistingFavorite(payload).then(data => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.$toast.success(data.message);
                        favInfo.show_in_bookmark_bar = false;
                    } else {
                        this.$toast.error(data.message);
                    }
                });
            }
        },
        clickToPinBookmarksbar(){
            this.pinnedBookmarks = !this.pinnedBookmarks;
            let payload = {'_id':this.getLoggedInUserId(),params:{'pinned_bookmarks':this.pinnedBookmarks}};
            this.updateUserPreferences(payload).then(data => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
            });
        },
        cancelFavsUpdate(){
            this.favoritesListToDisplay = JSON.parse(JSON.stringify(this.favoritesList));
        },
        handleFavouritesNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message && notification.message.user_id == this.getLoggedInUserId()){
              let favInfo = notification.message
              if('type' in favInfo && favInfo.type && ['Saved Search', 'bookmark'].includes(favInfo.type)){
                if(notification.message_type == NotifierConstants.favoriteRemovedNotification){
                    if(!favInfo.show_in_bookmark_bar){
                        this.favoritesList = this.favoritesList.filter(op=>op._id != favInfo._id)
                    }
                }
              }
            }
        },
        registerWebsocketNotifier(){
            this.addWSEventListener({
                eventname:[NotifierConstants.favoriteCreatedNotification, NotifierConstants.favoriteModifiedNotification, NotifierConstants.favoriteRemovedNotification],
                callback:this.handleFavouritesNotification,
                parent:"bookmarksBar"
            });
        },
        unRegisterWebsocketNotifier(){
            this.removeWSEventListener({
                eventname:[NotifierConstants.favoriteCreatedNotification, NotifierConstants.favoriteModifiedNotification, NotifierConstants.favoriteRemovedNotification],
                callback:this.handleFavouritesNotification,
                parent:"bookmarksBar"})
        },
        ...mapActions("favorites", ["addNewFavorite","updateExistingFavorite"]),
        ...mapActions("users", ["updateUserPreferences"]),
        ...mapGetters("users", ["getLoggedInUserId"]),
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener", "unsetWebsocket"]),
    },
    computed:{
        getFilteredFavourites(){
            return this.favoritesListToDisplay.reduce((acc, panel) => {
                let category = ''; // Optional category for anything else

                if(['bookmark'].includes(panel.type)){
                    category = 'Bookmarks';
                }else if(panel.type == 'Saved Search'){
                    category = 'Saved Search'
                }
                if (!acc[category]) {
                    acc[category] = [];
                }
                if (!this.filterFavouritesBy || panel.name.toLowerCase().includes(this.filterFavouritesBy.toLowerCase())) {
                    acc[category].push(panel);
                    this.openedPanel = [];
                }
                return acc;
            }, {});
        }
    },
    created(){
        this.favoritesListToDisplay = JSON.parse(JSON.stringify(this.favoritesList));
        if(Object.keys(this.getStartUpDataFromInCache()).includes('pinned_bookmarks')){
            this.pinnedBookmarks = this.getStartUpDataFromInCache().pinned_bookmarks;
        }
        this.registerWebsocketNotifier();
    },
    beforeDestroy(){
        this.unRegisterWebsocketNotifier();
    }
}
</script>

<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}
.bookmarks-bar{
    max-width: 98%;
    overflow: auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: flex;
        gap: 8px;
}

.activePanel{
    color: $active-blue !important;
    border: 1px solid $active-blue !important;
}

.activePanel:hover{
    border: 1px solid $active-blue !important;
}


.search-bar-comm-style {
    height: 30px;
    position: relative;
    padding-inline-start: 0px;
    width: 300px; /* Increased from 200px to 300px */
    margin-top: 5px;
    margin-bottom: 25px;
    margin-inline-start: 13px;

    input {
        border: $border-color;
        height: 39px;
        padding-inline-start: 3%;
        width: 100%; /* Ensure the input takes full width */
    }
  
    svg {
        position: absolute;
        inset-inline-end: 13px;
        top: 12px;
    }
}


.add-fav-button{
    background:transparent !important;
    border: 2px solid #21698f !important;
    color: #2d8fc3 !important;
    padding: 5px 10px;
    border-radius: 5px;
    svg{
        color: #2d8fc3 !important;
    }
}
    
.add-fav-button:hover{
    color:#eee !important;
    border: 2px solid #21698f !important;
    background:#21698f !important;
    svg{
        fill:#eee;
    }
}

.view-tags{
    font-size: 12px;
    display: inline-flex;
    margin:2px !important;
    border-radius: 15px !important;
    min-width: 65px;
    padding: 3px !important;
    text-align: center;
    border: 1px solid #4f4b4b;
    width:auto !important;
    background: $tags-background-color;
    position: relative;
    min-height: 55px;
    span{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 14px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
}

.icon-class{
    top:-1px;
    svg{
        height: 18px !important;
        width: 18px !important;
    }
}
.view-tags:hover{
    border: 1px solid #636363 !important;
}

.tags-display-ul{
    position: relative;
    user-select: none;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    .view-tags{
        display:flex;
        flex-direction: column;
        margin-bottom: 10px !important;
        align-items: center;
        justify-content: center;
        i{
            font-size: 20px;
        }
    }
  }

  .modal-dialog {
    width: 50% !important;
    height: 80%;
    margin: 0;
    padding: 0;
    max-width: 50% !important;
  }
  
 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height:300px;
      padding:10px;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100vh;
  vertical-align: middle;
  margin-inline-end: -4px;
  position: fixed;
  width: 100vw;
  inset-inline-start: 0;
  top: 0px;
  background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}
.modal-header .close {
    margin: -1rem -13px -1rem auto !important;
}

::-webkit-scrollbar {
    width: 8px;
    height:6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }
</style>